/**
 * @module components\ghTable\vuetifyTable\vuetifyRow\vuetifyCell\template\cellSelection
 */
import Vue from "vue";
import Component from "vue-class-component";
import Base from "../../base";
import { MethodService } from "@/utils/serviceModel";
import { State, namespace, Action, Getter } from "vuex-class";
import { Watch } from "vue-property-decorator";

const module = namespace("dbModule");

@Component
export default class CellSelection extends Base {
  @module.State(state => state.columnsSource)
  private sources: { [key: string]: IColumnSourceState };

  @module.State(state => state.currentColumnChangedId)
  private changedColumnId: string;

  @module.Action("fetchColumnSource")
  private fetch;

  private get loading() {
    if (this.sources && this.prop.Id) {
      let source = this.sources[this.prop.Id];
      if (source) {
        return source.loading;
      }
    }
    return false;
  }

  private items: any = null;

  private refresh() {
    this.fetch(this.prop.Id);
  }

  @Watch("sources")
  private observeChangedColumnId() {
    if (this.prop && this.prop.Id) {
      if (this.prop.Id === this.changedColumnId) {
        if (this.sources[this.prop.Id]) {
          this.items = this.sources[this.prop.Id].dataSource;
        }
      }
    }
  }

  created() {
    if (!this.items || this.items.length === 0) {
      this.refresh();
    }
  }
}
